import { Box, Paper } from '@material-ui/core';
import React, { useState } from 'react';
import { getPrimaryColorGradient } from '../utils/colors';
import { SelectField } from 'components/form/SelectField';
import { SNACKBAR_TIMEOUT } from 'components/constants';
import { useSnackbar } from 'notistack';

const getGradient = (palette: string) => {
  const gradients = [1, 2, 3, 4, 5, 6].map((num, index) => {
    const colors = getPrimaryColorGradient(num, palette);
    const isLastElement = index === [1, 2, 3, 4, 5, 6].length - 1;
    return (
      <Box
        display="flex"
        flexDirection="column"
        textAlign="center"
        key={num}
        style={{ marginRight: isLastElement ? '20px' : '0' }}
      >
        <b>{num}</b>
        {colors.map((c) => (
          <Box
            width="40px"
            height="30px"
            margin="4px"
            key={c}
            style={{ backgroundColor: c }}
          />
        ))}
      </Box>
    );
  });
  return gradients;
};

const TestGetGradientFn = () => {
const options = [
  {id: '0',value: 'green', label:'green original'},
  {id: '1',value: 'purple', label:'purple'},
  {id: '2',value: 'blue', label: 'blue'},
  {id: '3',value: 'red_blue', label: 'blue red'},
  {id: '4',value: 'blu_red', label: 'red blue'},
  {id: '5',value: 'green_magenta', label: 'green magenta'},
  {id: '6',value: 'magenta_green', label: 'magenta green'},
  ]
const [value, setValue] = useState(localStorage.getItem('testUserColorsPalette') || 'purple')
const { enqueueSnackbar } = useSnackbar();
return (
  <>
    <Paper style={{padding:'0.5rem'}}>
      <div style={{width:'200px'}}>
    <SelectField
    label='active palette'
    value={value}
    options={options}
    onChange={(e) => {setValue(e.target.value)
      localStorage.setItem('testUserColorsPalette', e.target.value)
      enqueueSnackbar(
       'palette successfully changed',
        {
          variant: 'success',
          autoHideDuration: SNACKBAR_TIMEOUT,
        },
      );
      setTimeout(() => window.location.reload(), 1500)
    }} />
    </div>
      <Box
        className="get-gradient-box"
        style={{flexWrap:'wrap'}}
      >
        {getGradient('green')}
        {getGradient('purple')}
        {getGradient('blue')}
        {getGradient('red_blue')}
        {getGradient('blu_red')}
        {getGradient('green_magenta')}
        {getGradient('magenta_green')}
      </Box>
    </Paper></>
)
}

export default TestGetGradientFn;
